export { RelayEnvironmentProvider } from "react-relay";
export { graphql, useEntryPointLoader, useFragment, useLazyLoadQuery, useMutation, usePaginationFragment, usePreloadedQuery, useQueryLoader, useRefetchableFragment, useSubscription, useRelayEnvironment, fetchQuery, } from "react-relay/hooks";
export { Environment, Network, RecordSource, Store } from "relay-runtime";
export function getEdgeNodes(connection) {
    if (!connection) {
        return [];
    }
    return (connection.edges || [])
        .map((edge) => {
        if (!edge || !edge.node) {
            return null;
        }
        return edge.node;
    })
        .filter((n) => n !== null);
}
export function getEdges(connection) {
    if (!connection) {
        return [];
    }
    return (connection.edges || [])
        .map((edge) => {
        return edge;
    })
        .filter((n) => n !== null);
}
//# sourceMappingURL=graphql.js.map